module.exports = __webpack_public_path__ + "/public/assets/frontend/get-coupon.gif";